const enrolledTeachingPeriodsByCourse = (
  state = {
    isFetching: false,
    receivedAt: null,
    teachingPeriods: []
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_ENROLLED_TEACHING_PERIODS':
      return {
        ...state,
        isFetching: true
      };
    case 'RECEIVE_ENROLLED_TEACHING_PERIODS':
      return {
        ...state,
        isFetching: false,
        teachingPeriods: action.teachingPeriods,
        receivedAt: Date.now()
      };
    default:
      return state;
  }
};

const enrolledTeachingPeriods = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        ...action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseCode]: enrolledTeachingPeriodsByCourse(
              state[currentCourse.courseCode],
              action
            )
          };
        }, {})
      };
    case 'REQUEST_ENROLLED_TEACHING_PERIODS':
    case 'RECEIVE_ENROLLED_TEACHING_PERIODS':
      return {
        ...state,
        [action.courseId]: enrolledTeachingPeriodsByCourse(
          state[action.courseId],
          action
        )
      };
    default:
      return state;
  }
};

export default enrolledTeachingPeriods;
